import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible'
import { Inbox, ChevronDown, ChevronUp } from 'lucide-react'
import PlatformIcon from '@/components/PlatformIcon'
import { formatDateOnly } from '@/lib/dateOnly'

interface CollaborationInfoCardProps {
  campaign: any
  isDetailsOpen: boolean
  setIsDetailsOpen: (isOpen: boolean) => void
  containerInvokeClass?: string // Allow parent to control sizing/order styles
}

const CollaborationInfoCard = ({
  campaign,
  isDetailsOpen,
  setIsDetailsOpen,
  containerInvokeClass,
}: CollaborationInfoCardProps) => {
  const formatDate = (dateString: string | null | undefined) => {
    return (
      formatDateOnly(dateString, 'en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }) ?? 'TBD'
    )
  }
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount)
  }

  return (
    <Collapsible
      open={isDetailsOpen}
      onOpenChange={setIsDetailsOpen}
      className={containerInvokeClass}
    >
      <Card className="bg-gray-900/90 backdrop-blur-xs border border-white/5 rounded-3xl rounded-bl-none">
        <CollapsibleTrigger className="w-full">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4">
            <div className="flex items-center gap-3">
              <Inbox className="h-5 w-5 text-white" />
              <CardTitle className="text-white">Collaboration Details</CardTitle>
            </div>
            {isDetailsOpen ? (
              <ChevronUp className="h-5 w-5 text-white" />
            ) : (
              <ChevronDown className="h-5 w-5 text-white" />
            )}
          </CardHeader>
        </CollapsibleTrigger>
        <CollapsibleContent>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
              {(campaign.startDate || campaign.endDate) && (
                <div>
                  <h3 className="text-sm font-medium text-gray-400 mb-1">DATES</h3>
                  <p className="text-gray-200">
                    {formatDate(campaign.startDate)} – {formatDate(campaign.endDate)}
                  </p>
                </div>
              )}
              <div>
                <h3 className="text-sm font-medium text-gray-400 mb-1">PLATFORM</h3>
                <div className="flex items-center gap-2">
                  <PlatformIcon platform={campaign.platform} className="h-5 w-5 text-gray-200" />
                  <p className="text-gray-200">{campaign.platform}</p>
                </div>
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-400 mb-1">COMPENSATION</h3>
                <p className="text-gray-200">{formatCurrency(campaign.paymentAmount)}</p>
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-400 mb-1">BRAND</h3>
                <div className="flex items-center gap-2">
                  <div className="h-6 w-6 rounded overflow-hidden bg-white/10">
                    <img
                      src={campaign.brand.logo}
                      alt={campaign.brand.name}
                      className="h-full w-full object-cover"
                    />
                  </div>
                  <p className="text-gray-200">{campaign.brand.name}</p>
                </div>
              </div>
            </div>

            <div className="mb-6">
              <h3 className="text-sm font-medium text-gray-400 mb-1">BRIEF</h3>
              <p className="text-gray-200">{campaign.brief}</p>
            </div>
          </CardContent>
        </CollapsibleContent>
      </Card>
    </Collapsible>
  )
}

export default CollaborationInfoCard
